import animateScroll from '../../../helpers/animateScroll';
import dom from '../../../wrapper/DomWrapper';
import triggerLoadLazyImages from '../../LazyLoad/utils/triggerLoadLazyImages';

// eslint-disable-next-line import/no-cycle
import { getHeaderOffset } from './index';

export default async () => {
  const { hash } = dom.window.location;

  if (!hash || !hash.startsWith('#s-')) return;

  const elSection = dom.getElement(hash);

  if (!elSection) return;

  dom.window.scrollTo(0, 0);
  await triggerLoadLazyImages();

  const endPosition = elSection.offsetTop;
  const headerOffset = getHeaderOffset();
  const position = endPosition - headerOffset;

  animateScroll(position, {
    duration: 100,
  });
};
